
import { apiUpdateUserPreference } from '../../core/redux/api/endpoints';
import { ACTION_TYPE } from '../../core/redux/actionType';
import { UserState } from '../../auth/userState';
import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../../core/redux/api/reduxStandardApiAction';
import { IAppState } from '../../core/redux/IAppState';
import { hasTrippedBreaker, updateBreaker } from '../../core/redux/api/circuitBreaker/module';
import { addError, addLoading, getLoading, removeLoadingAndError } from '../../core/redux/api/module';
import { UserAr } from './userAr';
import { assoc } from 'ramda';
import { updateIn } from '../../language/module';
import { updateUser } from './module';


export const KEY_ACTION = ACTION_TYPE.UPDATE_USER_PREFERENCE_REQUEST;

export const ACTIONS = [
  ACTION_TYPE.UPDATE_USER_PREFERENCE_REQUEST,
  ACTION_TYPE.UPDATE_USER_PREFERENCE_RESPONSE,
  ACTION_TYPE.UPDATE_USER_PREFERENCE_ERROR,
];

export const updateUserPreferencesAction = (user: UserState, languageCode: string, dateCode: string) => makeApiAction(
  {
    method:   'PUT',
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    endpoint: apiUpdateUserPreference(user.userId, encodeURIComponent(languageCode), dateCode.replaceAll('/','-')),
    types:    ACTIONS.map(action => ({ type: action, meta: { user } })) as RsaaTypes,
    bailout:  (state: IAppState) => hasTrippedBreaker(state, KEY_ACTION)
      || !!getLoading(state, user.userId, KEY_ACTION),
    }
);

const reducer: ApiReducer<any> = (state, action, error, isLoading) => {
  const newUser = action.meta.user as UserAr;

  if (isLoading) {
    return addLoading(state, newUser.userName, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(withBreaker, newUser.userName, KEY_ACTION, error);
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, newUser.userName, KEY_ACTION);

  return assoc(
    'users',
    updateIn(
      user => updateUser(user, newUser),
      user => user.userName === newUser.userName,
      noLoadingOrError.users || [],
    ),
    noLoadingOrError,
  );
}

export const updateUserPreferenceReducer = makeApiReducer(ACTIONS, KEY_ACTION, reducer);